<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :model="searchForm" :inline="true" size="mini" ref="searchForm" label-width="100px">
          <el-form-item label="商品编码">
            <el-input v-model="searchForm.goodsCode" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="商品名称">
            <el-input v-model.trim="searchForm.goodsName" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="适用店铺">
            <el-select v-model="searchForm.storeCode" placeholder="请选择" filterable clearable @change="onSearch">
              <el-option v-for="item in storeList" :key="item.storeCode" :label="item.storeName" :value="item.storeCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发货周期">
            <el-select v-model="searchForm.deliveryCycle" placeholder="请选择" filterable clearable @change="onSearch">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in deliveryCycleList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="small" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="small" @click="add(null)">新增</el-button>
        <el-button type="primary" size="small" @click="importExcel">导入</el-button>
        <el-button type="primary" size="small" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        :data="tableData.list"
        ref="tableRef"
        border
        :height="maxTableHeight"
        @sort-change="handleSortChange"
        v-loading="loading"
      >
        <el-table-column label="商品编码" prop="goodsCode" show-overflow-tooltip width="200"> </el-table-column>
        <el-table-column label="商品名称" prop="goodsName" show-overflow-tooltip> </el-table-column>
        <el-table-column label="适用店铺" prop="storeName" show-overflow-tooltip> </el-table-column>
        <el-table-column label="发货周期" prop="deliveryCycle" show-overflow-tooltip width="100"> </el-table-column>
        <el-table-column label="更新人" prop="updateBy" show-overflow-tooltip width="100"> </el-table-column>
        <el-table-column label="更新时间" prop="updatedDate" show-overflow-tooltip width="200"> </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="add(scope.row)">编辑</el-button>
            <el-button type="text" @click="record(scope.row)">调整记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
            background
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>
    <edit-dilog :visible.sync="dialogVisible" v-if="dialogVisible" :rowData="rowData" :storeListEdit="storeListEdit" @success="onSearch" />
    <adjusting-records :visible.sync="isShowRecords" v-if="isShowRecords" :rowData="rowData" />
  </content-panel>
</template>

<script>
import axios from "@/utils/axiosInstance";
import editDilog from "./components/edit";
import adjustingRecords from "./components/adjustingRecords";
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
import moment from "moment";
export default {
  name: "DeliverycycleSalesEnd",
  mixins: [tableMixin, pagePathMixin],
  components: { editDilog, adjustingRecords },
  data() {
    return {
      searchForm: {
        storeName: null,
        storeCode: null,
        deliveryCycle: '',
      },
      tableHeight: 0,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      reportName: 'goodsDeliverCycleSale',
      dialogVisible: false,
      isShowRecords: false,
      rowData: {},
      loading: false,
      searchFormData: {},
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
      storeList: [],
      deliveryCycleList: [],
      storeListEdit: [],
    };
  },
  computed: {},
  mounted() {
    this.onSearch()
    this.getStoreListEdit();
  },
  methods: {
    onSearch() {
      let goodsCode = this.searchForm.goodsCode && this.searchForm.goodsCode.split(" ").filter((v) => v).length > 1000;  //商品编码
      if (goodsCode) {
        this.$message.error("已超过1000条，请核对！");
        return;
      }
      // this.$refs.tableRef.clearSelection();
      this.tableData.pageNum = 1;
      this.queryCriteria = [
        {
          attributeName: "goodsCode", //商品编码
          val: this.searchForm.goodsCode ? this.searchForm.goodsCode.split(' ') : [],
          op: "in",
        },
        {
          attributeName: "goodsName", //办事处
          val: this.searchForm.goodsName ? this.searchForm.goodsName : "",
          op: "like",
        },
        {
          attributeName: "storeCode", //适用店铺
          val: this.searchForm.storeCode ? this.searchForm.storeCode : "",
          op: "like",
        },
        {
          attributeName: "deliveryCycle", //发货周期
          val: [this.searchForm.deliveryCycle ? this.searchForm.deliveryCycle : ""],
          op: "in",
        },
      ];
      this.init();
    },
    async init(type) {
      this.loading = true;
      let filter = this.queryCriteria.filter((item) => item.val.length && item.val[0]);
      let data = {
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
        reportCode: this.reportName,
        param: {},
        queryMatch: filter || [],
        orderList: [],
        orderByColumn: "",
        orderType: "",
        hasCount: "Y",
      };
      if (type) {
        data.queryMatch = type.queryMatch;
        data.orderList = type.orderList;
      }
      this.searchFormData = data;
      axios
        .post(`/ec-pc-api/custom/reports/data/${this.reportName}`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.getDeliveryCycleList();
          this.getStoreList();
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },
    // 重置
    reset() {
      this.tableData.pageNum = 1;
      this.tableData.pageSize = 30;
      this.searchForm = {
        storeName: null,
        storeCode: null,
        deliveryCycle: '',
      };
      this.onSearch();
    },
    handleSortChange({ column, prop, order }) {
      let type = order === "ascending" ? "0" : order === "descending" ? "1" : false;
      this.tableData.pageNum = 1;
      this.orderDto = {
        sortField: prop,
        sortOptions: order === "ascending" ? "0" : order === "descending" ? "1" : "",
      };
      this.orderDto = type ? this.orderDto : {};
      this.init();
    },
    add(row) {
      this.rowData = row ? {...row} : row;
      this.dialogVisible = true;
    },
    record(row) {
      this.rowData = {...row};
      this.isShowRecords = true
    },
    //导入
    importExcel() {
      this.openSubPage({
        //核心语句
        path: "/goods/deliverycycleSalesEndImport",
        // name: 'importexcelbyspu',   //跳转的路径
        query: {
          //路由传参时push和query搭配使用 ，作用时传递参数
          // fileType: '18',
          fileName: "商品销售端发货周期维护.xlsx",
          appCode: "ec-pc-new",
          reportName: "goodsDeliverCycleSaleImport",
        },
      });
    },
    // 导出
    exportExcel() {
      console.log(this.searchFormData)
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let params = {
        appCode: 'ec-pc-new',
        // paramMap: this.searchFormData.filterData,
        paramMap: {
          ...this.searchFormData
        },
        reportName: this.reportName
      }
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！')
        } else {
          this.$message.error(res.message)
        }
      }).finally(_=> {
        loading.close()
      })
    },
    //发货周期
    getDeliveryCycleList() {
      let data = JSON.parse(JSON.stringify(this.currencyForm));
      data.groupAttr = "deliveryCycle";
      data.reportCode = this.reportName;
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.deliveryCycleList = data;
      });
    },
    //适用店铺
    getStoreList() {
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm));
      currencyForm.reportCode = "goodsDeliverCycleSaleStoreList";
      axios.post(`/ec-pc-api/custom/reports/data/goodsDeliverCycleSaleStoreList`, currencyForm).then((res) => {
        if (res.code == 200) {
          this.storeList = res.data.list;
        }
      });
    },
    //编辑、新增弹窗内店铺
    getStoreListEdit() {
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm));
      currencyForm.reportCode = "storeInfoList";
      currencyForm.param = {
        // report: '是',
      }
      axios.post(`/ec-pc-api/custom/reports/data/storeInfoList`, currencyForm).then((res) => {
        if (res.code == 200) {
          this.storeListEdit = res.data.list;
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
body {
  height: auto !important
}
.panel-in-tab
  >>> .search-outer>div
    padding 0
</style>
<style lang="css">
.el-tooltip__popper {
  max-width: 40%;
}
</style>
